export type CameraPickerButtonProps = {
  isLoading: boolean;
  onPermissionCheckStart: () => void;
  onPermissionCheckComplete?: () => void;
  onPermissionDenied?: () => void;
  setIsLoading: (loading: boolean) => void;
  openCamera: () => void;
  /** Fires on the tap itself, ahead of the permission prompt. */
  onPressed?: () => void;
  /** Camera access is unavailable; the user got the settings alert instead. */
  onPermissionBlocked?: () => void;
};
export const CameraPickerButton = (_: CameraPickerButtonProps) => {
  console.error("Not implemented for web");
  return null;
};